<ion-content *ngIf="activeOrder">
  <ion-grid>
    <ion-row>
      <!-- ORDER SUMMARY SECTION -->
      <ion-col class="order-summary-col" size="3">
        <ion-list lines="none">
          <ion-list-header class="header-title">
            <span
              class="context-icon icon icon-{{ activeOrder.filter_module }} {{ activeOrder.filter_module }}-bg-color"
            ></span>
            Order Summary
          </ion-list-header>

          <ion-item *ngFor="let item of orderSummary">
            <ion-label class="order-item-summary-label">
              <div class="item-qty">{{ item.qty | fraction }}</div>
              <div class="item-title">{{ item.title }}</div>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>

      <!-- TIME SELECTOR SECTION -->
      <ion-col class="eta-col" size="7">
        <div class="eta-col-block eta-col-header">
          <h3 class="header-title">Confirm ETA</h3>

          <!-- <ion-button *ngIf="pending > 1" class="close-btn" fill="clear" (click)="close(true)">
            Dismiss all ({{pending}})
          </ion-button> -->

          <ion-button class="close-btn" fill="clear" (click)="close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </div>

        <div
          class="semibold eta-col-block eta-col-summary ion-text-center"
          [class.deliveryWindow]="order.is_delivery_window"
          [innerHTML]="eta_message"
        ></div>

        <ng-container *ngIf="!order.is_delivery_window">
          <!-- CHANGE TIME -->
          <div class="eta-col-block eta-col-timeselect" *ngIf="etaTimeState !== 'custom'">
            <ion-item class="date-selector" lines="none" *ngIf="etaTimeState === 'change'">
              <ion-button slot="start" shape="round" fill="clear" size="large" (click)="addTime(-1, 'day')">
                <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
              </ion-button>

              <div class="date-selected ion-text-center">
                <span class="date-selected-day-str"> {{ tempDayStr }} </span><br />
                <span class="date-selected-date-str">
                  {{ tempDateStr }}
                </span>
              </div>

              <ion-button slot="end" shape="round" fill="clear" size="large" (click)="addTime(1, 'day')">
                <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
              </ion-button>
            </ion-item>

            <ion-item class="time-selector" lines="none">
              <ion-button
                slot="start"
                fill="outline"
                shape="round"
                size="large"
                class="eta-large minus-10-minutes"
                (click)="addTime(-10, 'minute')"
              >
                -10
              </ion-button>

              <ion-button
                slot="start"
                fill="outline"
                shape="round"
                size="small"
                class="eta-small minus-5-minutes"
                (click)="addTime(-5, 'minute')"
              >
                -5
              </ion-button>

              <div class="time-selected ion-text-center">
                {{ tempEtaStr }}
              </div>

              <ion-button
                slot="end"
                fill="outline"
                shape="round"
                size="large"
                class="eta-small plus-5-minutes"
                (click)="addTime(5, 'minute')"
              >
                +5
              </ion-button>

              <ion-button
                slot="end"
                fill="outline"
                shape="round"
                size="large"
                class="eta-large plus-10-minutes"
                (click)="addTime(10, 'minute')"
              >
                +10
              </ion-button>
            </ion-item>
          </div>

          <!-- CUSTOM TIME -->
          <div class="eta-col-block eta-col-timeselect" *ngIf="etaTimeState === 'custom'"></div>
        </ng-container>

        <div class="eta-col-block eta-col-buttons">
          <ion-button
            *ngIf="!order.is_delivery_window && (etaTimeState === 'default' || etaTimeState === 'custom')"
            (click)="changeTimeState('change')"
            class="custom-time-btn"
            fill="outline"
            shape="round"
            size="large"
          >
            Change Date
          </ion-button>

          <!-- <ion-button *ngIf="etaTimeState == 'change'" (click)="changeTimeState('custom')"  class="custom-time-btn" fill="outline" shape="round" size="large">
            Custom Time
          </ion-button> -->

          <ion-button class="hub-btn" shape="round" size="large" (click)="confirm()"> Confirm & Send SMS </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
